import { render } from "./ModernServices.vue?vue&type=template&id=fe31c284&scoped=true"
import script from "./ModernServices.vue?vue&type=script&lang=js"
export * from "./ModernServices.vue?vue&type=script&lang=js"

import "./ModernServices.vue?vue&type=style&index=0&id=fe31c284&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe31c284"]])

export default __exports__